import React, { useEffect } from 'react';
import { getRouteMeta } from '../routeMetadata';
import { shelfForLink } from './Product/productData';
import { trackGooglePageView } from '../analytics/googleAnalytics';
import { startProductSession, trackPageView } from '../analytics/mixpanel';

interface RouteChangeTrackerProps {
    location: any;
    notFound?: boolean;
}

const RouteChangeTracker: React.FC<RouteChangeTrackerProps> = ({ location, notFound }) => {
    useEffect(() => {
        if (location && notFound) {
            document.title = 'Page Not Found';
            trackGooglePageView('/unknown', '', document.title);
            trackPageView('/unknown');
            return undefined;
        }
        if (location) {
            const meta = getRouteMeta(location.pathname);
            const shelf = location.pathname === '/' ? shelfForLink(new URLSearchParams(location.search)) : undefined;
            if (shelf || meta) {
                document.title = shelf?.name ?? meta!.title;
            }
            trackGooglePageView(location.pathname, location.search, document.title);
            trackPageView(location.pathname);
            return startProductSession(location.pathname);
        }
    }, [location, notFound]);

    return null;
};

export default RouteChangeTracker;
